// extracted by mini-css-extract-plugin
export default {"image":"nha-z","loaded":"oha-z"};